import { Rental } from "@/types/rental.type";
import { formatDateTimeAutoToString } from "@/utils/format";
import { ColumnDef } from "@tanstack/react-table";
import _ from "lodash";
import { useTranslation } from "react-i18next";

export default function TableHeaderExired(): ColumnDef<Rental>[] {
    const {t} = useTranslation();

    return [
        {
            header: t("rental.business_unit"),
            accessorKey: "room.business_unit.name",
            enableSorting: false
        },
        {
            header: t("rental.room"),
            accessorKey: "room.code",
            enableSorting: false
        },
        {
            header: t("rental.end_date"),
            accessorKey: "end_date",
            enableSorting: false,
            cell: ({row}) => formatDateTimeAutoToString(row.original.end_date ?? '', "ll")
        }
    ]
}

export function TableHeaderFuture(): ColumnDef<Rental>[] {
    const {t} = useTranslation();

    return [
        {
            header: t("rental.business_unit"),
            accessorKey: "room.business_unit.name",
            enableSorting: false
        },
        {
            header: t("rental.room"),
            accessorKey: "room.code",
            enableSorting: false
        },
        {
            header: t("rental.type"),
            accessorKey: "type",
            enableSorting: false,
            cell: ({row}) => row.original.type === 1 ? t("rental.will_rent") : t("rental.type_renew")
        },
        {
            header: t("rental.start_date"),
            accessorKey: "start_date",
            enableSorting: false,
            cell: ({row}) => formatDateTimeAutoToString(row.original.start_date ?? '', "ll")
        },
        {
            header: t("rental.end_date"),
            accessorKey: "end_date",
            enableSorting: false,
            cell: ({row}) => formatDateTimeAutoToString(row.original.end_date ?? '', "ll")
        }
    ]
}
